import { Directive, input, Input } from '@angular/core'
import { MatTab } from '@angular/material/tabs'

@Directive({
	selector: 'mat-tab',
	exportAs: 'lowgileTabGroupTabControl',
	standalone: false,
})
export class TabGroupTabControlDirective {
	lowgileTabName = input<string | undefined>()

	constructor(private matTab: MatTab) {}

	getTabName() {
		return this.lowgileTabName() ?? this.matTab.textLabel
	}
}
